var Model       = require("Model"),
    ol          = require("openlayers"),
    Events      = require("Events");

var Layer = Model.extend({

    includes: Events,

    /**
     *
     */
    initialize: function(options) {
        var that = this,
            attributes;

        options || (options = {});
        attributes = options.attributes || {};
        delete options['attributes'];

        Layer.__super__.initialize.call(that, attributes, options);

        that._prjLayers = false;
        that._olSource = undefined;
        that._olLayer = undefined;

        if ('projectLayers' in that.options) {
            that._prjLayers = that.options['projectLayers'];
            delete that.options['projectLayers'];
        }
    },

    /**
     *
     */
    onAdd: function(view){
        var that = this;

        that._view = view;
        return void (0);
    },

    /**
     *
     */
    show: function(){
        var that = this;

        if (that._olLayer !== undefined) {
            that['_olLayer'].setVisible(true);
        }
    },

    /**
     *
     */
    hide: function(){
        var that = this;

        if (that._olLayer !== undefined) {
            that['_olLayer'].setVisible(false);
        }
    },

    /**
     *
     */
    isVisible: function(){
        var that = this;
        return that._olLayer !== undefined ? that._olLayer.getVisible() : false;
    },

    /**
     *
     */
    toggle: function(){
        var that = this;

        that.isVisible() ? that.hide() : that.show();
    },

    /**
     *
     */
    getMapLayer: function(){
        return this._olLayer;
    },

    /**
     *
     */
    getProjectLayers: function(){
        return this._prjLayers;
    },

    /**
     *
     */
    setMapLayer: function(layer){
        var that = this;
        if (layer instanceof ol.layer.Base) {
            that._olLayer = layer;
        }
    },

    /**
     *
     */
    setSource: function(source){
        var that = this;
        if (source instanceof ol.source.Source) {
            that._olLayer.setSource(source);
        }
    },

    getSource: function(){
        var that = this;
        return that._olLayer.getSource();
    }
});

module.exports = Layer;



//////////////////
// WEBPACK FOOTER
// ./src/View/Layer.js
// module id = 41
// module chunks = 0